"use strict";

import { StudijnyProgram } from "./studijny-program";


export class ZaznamTextu {

	id: number;
  //blob
	text: string;
	textString: string;
  poradie: number;
	modifikator: string;
  //timestamp
	poslModif: string;
	idOsoba: number;
	idTypZaznamTextu: number;
	idStudProgram: number;
  idPodprogram: number;
	kodJazyk: string;

  studijneProgramy: StudijnyProgram[];

  // I - INSERT, U - UPDATE, D - DELETE
  change: string;

  podprogram: string;
  idPodprogramSpolocnaPolozka: number;

  // v premennych "stupneStudia" a "typyStudia" uchovame to, pre ake stupne
  // a typy studia je zaznam urceny (podla parametra "vazba === 1" z SCSTTypZaznamuTextu)
  stupneStudia: string[];
  typyStudia: string[];

}
